<template>
  <div>
    <img :src="srcPalette" alt="Paleta kolorów" class="palette-image" />
    <div class="palette" :class="{ 'vertical-palette': direction == 'vertical' }" :style="paletteStyle">
      <div v-for="(item, index) in colors" :key="index">
        <color @pick-color="pickColor" :color="item" :style="colorStyle"></color>
        <img src="./img/obramowanie.png" v-show="item == color" class="frame" />
      </div>
    </div>
  </div>
</template>

<script>
import color from './color';
export default {
  name: 'palette',
  components: {
    color,
  },
  props: {
    colors: {
      type: Object,
      default: function() {
        return {};
      },
    },
    direction: {
      type: String,
      default: 'horizontal',
    },
    srcPalette: {
      type: String,
      default: '',
    },
    paletteStyle: {
      type: Object,
      default: function() {
        return {};
      },
    },
    colorStyle: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {
      color: '#ffffff',
    };
  },
  methods: {
    pickColor(event) {
      this.color = event;
      this.$emit('pick-color', this.color);
    },
  },
};
</script>

<style lang="scss">
.palette {
  position: absolute;
  display: flex;
  z-index: 2;
}
.palette-image {
  position: absolute;
  z-index: 1;
}
.vertical-palette {
  flex-direction: column;
}
.frame {
  position: absolute;
  margin-left: -35px;
  margin-top: -62px;
}
</style>
